<template>
  <!-- <div> -->

  <v-expand-transition>
    <!-- <div v-if="viewingPlaintiff"> -->
    <v-expand-transition v-if="viewingDefendant">
      <div>
        <v-spacer></v-spacer>
        <v-card-actions>
          <v-btn text rounded outlined @click="clearDefendant">clear defendant</v-btn>
          <v-spacer></v-spacer>
          <v-btn text rounded outlined>edit defendant</v-btn>
        </v-card-actions>
        <v-card-text class="white--text title">NAME: {{ viewingDefendant.fullName }}</v-card-text>
        <v-card-text class="white--text title">DOB: {{ viewingDefendant.dateOfBirth || "none" }}</v-card-text>
        <v-card-text class="white--text title">ENTITY TYPE: {{ viewingDefendant.type }}</v-card-text>
        <v-card-text class="white--text title">PHONE: {{ viewingDefendant.phone }}</v-card-text>
        <v-card-text class="white--text title">EMAIL: {{ viewingDefendant.email }}</v-card-text>
        <v-card-text class="white--text title mt-1">
          ADDRESS: {{ viewingDefendant.addressLine1 }},
          {{ viewingDefendant.cityStateZip }}
        </v-card-text>
      </div>
    </v-expand-transition>
    <!-- </div> -->
    <div v-if="!viewingDefendant">
      <v-card-text>SELECT A DEFENDANT TO VIEW</v-card-text>
    </div>
  </v-expand-transition>

  <!-- </div> -->
</template>

<script>
//
//
//
//THIS ENTIRE COMPONENT MUST BE CHANGED TO MACH THE ViewPlaintiff COMPONENT
//
//
//
export default {
  data() {
    return {};
  },
  computed: {
    viewingDefendant() {
      // if (
      //   this.$store.viewingParty == null ||
      //   this.$store.viewingParty == undefined
      // ) {
      //   return "select a party";
      // } else {
      //   return this.$store.viewingParty;
      // }
      return this.$store.getters.defendant;
    },
  },
  methods: {
    clearDefendant() {
      this.$store.dispatch("clearDefendant");
    },
  },
};
</script>

<style lang="scss" scoped></style>
